import React, { useEffect, useRef, useState } from 'react';

interface TypeExplanationProps {
  summary: string;
  paragraphs: string[];
}

export default function TypeExplanation({ summary, paragraphs }: TypeExplanationProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="px-5 py-10 md:px-8 md:py-14">
      <div
        className={`mx-auto max-w-[480px] transition-all duration-700 md:max-w-[700px] ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        {/* section label */}
        <div className="mb-6 flex items-center gap-2">
          <div className="h-px w-6 bg-softgold/40" />
          <span className="text-[11px] font-medium tracking-wider text-softgold">
            성향 해석
          </span>
        </div>

        {/* summary quote */}
        <blockquote className="mb-8 border-l-2 border-softgold/40 pl-4">
          <p className="text-[15px] font-medium leading-relaxed text-navy md:text-[16px]">
            {summary}
          </p>
        </blockquote>

        {/* paragraphs */}
        <div className="space-y-4">
          {paragraphs.map((text, i) => (
            <p
              key={i}
              className="text-[13px] leading-[1.9] text-navy/70 md:text-[14px]"
            >
              {text}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}